export default "https://cdn-static.gokick.com/assets/46c46890c219de5164704b27b734f3ae915944d1/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";